export const garrisonTimelineFilters = {
  dtStart: null,
  dtEnd: null,
  leaderId: null,
  team: null,
  contingent: null
}

export const garrisonTimelineErrorMappings = Object.freeze({
  "crud.listener.upsert.null.datetime.start": 'O campo "Data/hora inicial" é obrigatório.',
  "crud.listener.upsert.null.datetime.end": 'O campo "Data/hora final" é obrigatório.',
  "crud.listener.upsert.null.garrison": "Selecione ao menos uma guarnição.",
  "validation.timeline.invalid.format": "O formato da data e hora é inválido. Utilize o padrão dd/MM/yyyy HH:mm.",
  "validation.timeline.date.start.after.end": "A data inicial não pode ser posterior à data final.",
  "validation.timeline.period.exceeds.limit": "O período selecionado excede o limite máximo permitido de 24 horas.",
  "validation.timeline.invalid.page": "A página informada é inválida.",
  "validation.timeline.garrisons.limit.exceeded": "A pesquisa excede o limite de 100 guarnições. Refine os filtros aplicados.",
  "validation.timeline.locations.limit.exceeded": "A pesquisa excede o limite de localizações permitido. Refine os filtros ou reduza o período.",
});

export const garrisonTimelineModes = Object.freeze({
  map: "MAP",
  timeline: "TIMELINE",
  route: "ROUTE"
});

export const garrisonTimelineKeys = Object.freeze({
  timeline: (filters, page) => ["garrison-timeline", filters, page],
  print: (filters) => ["garrison-timeline-print", filters],
  snapshot: (filters, instant, page = null) => ["garrison-timeline-snapshot", filters, instant, page],
  leaders: () => ["leaders"],
  teams: () => ["teams"],
  corporation: () => ["corporation"],
  contingent: () => ["contingents"],
  route: (id, dtStart, dtEnd, orderIndex) => ["garrison-timeline-route", id, dtStart, dtEnd, orderIndex],
});

export const buildGarrisonTimelinePrintUrl = ({filters, zoom, elapsedSeconds, cropRange}) => {
  const queryParams = new URLSearchParams();

  Object.entries(filters ?? {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") queryParams.set(key, String(value));
  });

  queryParams.set("zoomStart", String(zoom?.start ?? 0));
  queryParams.set("zoomEnd", String(zoom?.end ?? 100));
  queryParams.set("elapsedSeconds", String(elapsedSeconds ?? 0));
  if (cropRange?.length === 2) {
    queryParams.set("cropStart", String(cropRange[0]));
    queryParams.set("cropEnd", String(cropRange[1]));
  }

  return `/despacho/garrison-timeline/print?${queryParams.toString()}`;
};

export const garrisonTimelineViewLayoutSize = Object.freeze({
  h: 40,
})

export const TABLE_MODES = Object.freeze({
  SOLVE_CLUSTER: "SOLVE_CLUSTER",
  SELECT_ITEMS: "SELECT_ITEMS",
});

export const buildGarrisonRouteUrl = (garrisonId, filter, orderIndex) => {
  if (garrisonId === undefined || garrisonId === null || garrisonId === "") return null;

  const queryParams = new URLSearchParams();

  Object.entries(filter ?? {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "" || Array.isArray(value)) return;
    if (typeof value === "number" && !Number.isFinite(value)) return;
    if (typeof value !== "string" && typeof value !== "number" && typeof value !== "boolean") return;

    queryParams.set(key, String(value));
  });

  if (Number.isInteger(orderIndex) && orderIndex > 0) {
    queryParams.set("orderIndex", String(orderIndex));
  }

  const queryString = queryParams.toString();

  return `/despacho/garrison-timeline-route/${encodeURIComponent(garrisonId)}${queryString ? `?${queryString}` : ""}`;
};

export const ROUTE_LEGEND_ITEMS = [
  {label: "Despacho", colorClassName: "bg-[#008C51]"},
  {label: "Em atividade", colorClassName: "bg-[#287499]"},
  {label: "Disponível", colorClassName: "bg-[#808080]"},
  {label: "Sem sinal", colorClassName: "bg-[repeating-linear-gradient(45deg,#EAEAEA,#EAEAEA_4px,#B3B3B3_4px,#B3B3B3_5px)]"},
  {label: "Offline", colorClassName: "bg-[repeating-linear-gradient(45deg,#4B5563,#4B5563_4px,#DC2626_4px,#DC2626_5px)]"}
];
